export default __webpack_public_path__ + "f23a73f0146392949600780d91b33b58.png";